import React from 'react';

import Button from '../button/button';

import './menu.styl'
class Menu extends React.Component {

    state = {
        open: false
    }

    openClose = () => this.setState({open: !this.state.open})

    label = () => this.state.open ? 'app.close' : 'app.open'

    className = this.props.className ? ' '  + this.props.className : ''

    render = () => <div className='menu'>
        <Button className="menu-opener" onClick={this.openClose} label={this.label()} />
        <div className={'menu-container' +  this.className + (this.state.open? ' open' : '')}>
            {this.props.children}
        </div>
    </div>
}

export default Menu